module.exports = __webpack_public_path__ + "img/ZM.54eab0a4.png";